import { createFeatureSelector, createSelector } from '@ngrx/store';

import { State, reportFeatureKey } from './report.reducer';

const selectReportState = createFeatureSelector<State>(reportFeatureKey);

// Raw selectors

export const getHistoricReports = createSelector(selectReportState, (state: State) => state.historics);

export const getFavoriteReports = createSelector(selectReportState, (state: State) => state.favorites);

export const getCurrentReport = createSelector(selectReportState, (state: State) => state.currentReport);

export const getIsPropertyPanel = createSelector(selectReportState, (state: State) => state.isPropertyPanel);

export const getIsChartPanel = createSelector(selectReportState, (state: State) => state.isChartPanel);

export const getIsExporting = createSelector(selectReportState, (state: State) => state.isExporting);

export const getGeneratingReport = createSelector(selectReportState, (state: State) => state.generatingReport);

export const getIsPreview = createSelector(selectReportState, (state: State) => state.isPreview);

export const getPreviewReport = createSelector(selectReportState, (state: State) => state.previewReport);

export const getPreviewData = createSelector(selectReportState, (state: State) => state.previewData);

// Calculated selectors
